const handleMask = (event: React.KeyboardEvent<HTMLInputElement>, mask: string) => {
    const target = event.target as HTMLInputElement;

    event.stopPropagation();
    event.preventDefault();

    // If charCode is not available
    if (!event.charCode) return;

    const c = String.fromCharCode(event.charCode);
    // If character is not a digit, exit
    if (c.match(/\D/)) return;

    let val = target.value.substring(0, target.selectionStart!) + c + target.value.substr(target.selectionEnd!);
    let pos = target.selectionStart! + 1;

    // Count NaN values (non-numeric characters) before removing the separators
    const nan = count(val, /\D/, pos);
    val = val.replace(/\D/g, '');

    const maskParts = mask.match(/^(\D*)(.+9)(\D*)$/);
    if (!maskParts) return; // Throw an exception if needed

    // Check if value exceeds the number of 9's in the mask
    if (val.length > count(maskParts[2], /9/)) return;

    let txt = '';
    let im = 0;
    let iv = 0;

    // Create the masked value
    while (im < maskParts[2].length && iv < val.length) {
        const maskChar = maskParts[2].charAt(im);
        txt += maskChar.match(/\D/) ? maskChar : val.charAt(iv++);
        im += 1;
    }

    // Update the target value
    target.value = maskParts[1] + txt + maskParts[3];

    // Update the selection range after input
    target.selectionStart = target.selectionEnd = pos + (pos === 1 ? maskParts[1].length : count(target.value, /\D/, pos) - nan);

    /**
     * Count occurrences of a pattern in a string up to a specific point
     *
     * @param str string to search
     * @param c pattern to match
     * @param e index to stop counting
     * @returns count of matches
     */
    function count(str: string, c: RegExp, e?: number): number {
        e = e || str.length;
        let n = 0;
        for (let i = 0; i < e; i += 1) {
            if (str.charAt(i).match(c)) n += 1;
        }
        return n;
    }
};

export default handleMask;
